import { render, staticRenderFns } from "./NotecardShimmer.vue?vue&type=template&id=6aa04bb7&"
import script from "./NotecardShimmer.vue?vue&type=script&lang=js&"
export * from "./NotecardShimmer.vue?vue&type=script&lang=js&"
import style0 from "./NotecardShimmer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports